/** Extrai só o nome do arquivo (sem path, query ou hash). */
export function extractImageFilename(value: string | null | undefined): string {
  if (!value || typeof value !== 'string') return '';
  const trimmed = value.trim();
  if (!trimmed) return '';
  if (trimmed.startsWith('data:')) return '';

  const withoutQuery = trimmed.split('?')[0].split('#')[0];
  const normalized = withoutQuery.replace(/\\/g, '/');
  const segments = normalized.split('/').filter(Boolean);
  const last = segments[segments.length - 1] ?? normalized;
  return last.trim();
}

/** Compara capa selecionada com uma foto (filename, path ou arquivo local). */
export function coverMatchesPhoto(
  coverValue: string,
  photo: { filename?: string; file?: File; url?: string },
): boolean {
  const cover = extractImageFilename(coverValue);
  if (!cover) return false;

  if (photo.filename && extractImageFilename(photo.filename) === cover) {
    return true;
  }
  if (photo.file?.name && extractImageFilename(photo.file.name) === cover) {
    return true;
  }
  if (photo.url && extractImageFilename(photo.url) === cover) {
    return true;
  }
  return false;
}

export function getPhotoFilename(photo: {
  filename?: string;
  file?: File;
  url?: string;
}): string {
  if (photo.filename) return extractImageFilename(photo.filename);
  if (photo.file?.name) return extractImageFilename(photo.file.name);
  if (photo.url) return extractImageFilename(photo.url);
  return '';
}
